import { Query } from '../Model/Query';
export class DirectionsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(directionId) {
        if (directionId) {
            const response = await this.apiService.get('direction/' + directionId);
            if (!response.ok) {
                //   throw new Error(`Error al obtener la dirección.`);  
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener directionId.`);
        }
    }
    async findDirections(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`directions?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener las direcciones.`);
            }
            const content = await response.json();
            return content.map(direction => new direction(direction).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveDirection(direction, thirdId) {
        if (direction) {
            const response = await this.apiService.post('direction', direction);
            if (!response.ok) {
                throw new Error(`Error al guardar el tercero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async directionExists(directionId) {
        if (directionId) {
            const response = await this.apiService.get('directionexists/' + directionId);
            if (!response.ok) {
                //   throw new Error(`Error al obtener la dirección.`);  
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener directionId.`);
        }
    }
}
